import React from 'react';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { SIDEBAR_PIXEL_WIDTH } from '../constants';
import { AccountMenu } from './AccountMenu';
import { COLORS } from '../styles/theme';

export interface HeaderProps {
  title?: string;
}

const StyledAppBar = styled(AppBar)(() => ({
  width: `calc(100% - ${SIDEBAR_PIXEL_WIDTH}px)`,
  marginLeft: SIDEBAR_PIXEL_WIDTH,
}));

const StyledTitle = styled(Typography)(() => ({
  flexGrow: 1,
}));

export const Header = ({ title }: HeaderProps) => {
  return (
    <StyledAppBar position="static" color="primary">
      <Toolbar style={{ paddingRight: '3px' }}>
        <StyledTitle variant="h6">
          <Link
            to="/app"
            style={{ color: COLORS.WHITE, textDecoration: 'none' }}
          >
            {title ? title : 'Home'}
          </Link>
        </StyledTitle>
        <AccountMenu />
      </Toolbar>
    </StyledAppBar>
  );
};
